import React from 'react';
import classNames from 'classnames';
import {
  Motion,
  spring
} from 'react-motion';

import SlideShow from '../slide-show';
import Logo from '../logo';


const homeImages = [
  require ('../../images/home_1.jpg'),
  require ('../../images/home_2.jpg'),
  require ('../../images/home_3.jpg'),
  require ('../../images/home_4.jpg'),
  require ('../../images/home_5.jpg')
]

class Home extends React.Component {
  constructor (){
    super ();
  }

  render () {
    return (
      <section className="home">
        <div className="home--slide-show-container">
          <SlideShow 
            imageUrls={homeImages} 
            onImageSet={this.setImage}
          />
        </div>
        <Motion defaultStyle={{y: 200}} style={{y: spring (0)}}>
          {interpolatingStyle => {
            const yPos = interpolatingStyle.y;
            const translate = {
              transform: `translateY(${yPos}px)`
            };
            return (
              <div className={"home--logo-container"} style={translate} >
                <Logo />
              </div>
            ); 
          }}
        </Motion>
      </section>
    )
  }
}

export default Home




// WEBPACK FOOTER //
// ./components/page-home/index.js